import { useMutation } from '@tanstack/react-query';
import { CompanyService } from './CompanyService';
import { BuyerSignupFormData } from '../../pages/Buyer/buyersignup.types';
import { backendServices, RecursivePartial } from 'common';

export function extractAPIErrorMessage(e: any) {
    if (e !== null) {
        return e.response.data.errors[0].Message ?? 'Unknown error';
    }
    return null;
}

export function useRegisterBuyerCompanyUserProfile() {
    const mutation = useMutation({
        mutationFn: async ({
            buyerSignupData,
            baseViewModel,
        }: {
            buyerSignupData: BuyerSignupFormData;
            baseViewModel: RecursivePartial<backendServices.ViewModels.BuyerCompanyUserProfileViewModel>;
        }) => {
            const companyService = new CompanyService();

            const res = await companyService.registerBuyerCompanyUserProfile(buyerSignupData, baseViewModel);

            const companyName = buyerSignupData.generalInformation.buyerCompanyName;
            return { res, companyName };
        },
    });

    return mutation;
}
